import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "news-container" }
const _hoisted_2 = { class: "card-header-modern" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "news-content" }
const _hoisted_6 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "news-details" }
const _hoisted_9 = { class: "news-header" }
const _hoisted_10 = { class: "news-title" }
const _hoisted_11 = { class: "news-description" }
const _hoisted_12 = { class: "news-date" }
const _hoisted_13 = {
  key: 2,
  class: "empty-state"
}

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

interface Notice {
  nc_idx: number;
  nc_type: string;
  nc_category: string;
  nc_sisul_name: string | null;
  nc_writer_name: string;
  nc_title: string;
  nc_wdate: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const newsList = ref<Notice[]>([]);

// 공지사항 로드
const loadNotices = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 5 },
      withCredentials: true
    });
    
    if (response.data.success) {
      newsList.value = response.data.notices;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  } finally {
    loading.value = false;
  }
};

// 상세 페이지로 이동
const goToDetail = (ncIdx: number) => {
  router.push(`/pgm/notice/${ncIdx}`);
};

// 유틸리티 함수들
const formatDate = (date: string) => {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
};

const isNew = (date: string) => {
  if (!date) return false;
  const d = new Date(date);
  const now = new Date();
  return (now.getTime() - d.getTime()) < 3 * 24 * 60 * 60 * 1000;
};

const getTypeClass = (category: string) => {
  switch (category) {
    case 'NOTICE': return 'info';
    case 'UPDATE': return 'update';
    case 'EVENT': return 'success';
    case 'URGENT': return 'warning';
    default: return 'info';
  }
};

const getIcon = (category: string): string => {
  const icons: Record<string, string> = {
    NOTICE: 'mdi-information',
    UPDATE: 'mdi-update',
    EVENT: 'mdi-party-popper',
    URGENT: 'mdi-alert'
  };
  return icons[category] || 'mdi-information';
};

const getIconColor = (category: string): string => {
  const colors: Record<string, string> = {
    NOTICE: '#1e3a8a',
    UPDATE: '#0097a7',
    EVENT: '#388e3c',
    URGENT: '#d32f2f'
  };
  return colors[category] || '#1e3a8a';
};

onMounted(() => {
  loadNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "news-card",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                class: "header-icon",
                color: "#1e3a8a"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-bell-ring", -1)
                ]))]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-text" }, [
                _createElementVNode("h3", { class: "card-title-modern" }, "공지사항"),
                _createElementVNode("p", { class: "card-subtitle" }, "중요한 알림과 업데이트")
              ], -1))
            ]),
            _createVNode(_component_router_link, {
              to: "/pgm/notice",
              class: "view-all-link"
            }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createTextVNode(" 전체보기 ", -1)),
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "24",
                  color: "primary"
                })
              ]))
            : (newsList.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newsList.value, (news, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["news-item", { 'important': news.nc_category === 'URGENT' }]),
                    onClick: ($event: any) => (goToDetail(news.nc_idx))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["news-icon-wrapper", getTypeClass(news.nc_category)])
                    }, [
                      _createVNode(_component_v_icon, {
                        color: getIconColor(news.nc_category),
                        size: "20"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getIcon(news.nc_category)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ], 2),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(news.nc_title), 1),
                        (news.nc_category === 'URGENT')
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              size: "x-small",
                              color: "error",
                              variant: "flat",
                              class: "important-badge"
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" 긴급 ", -1)
                              ]))]),
                              _: 1
                            }))
                          : (isNew(news.nc_wdate))
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 1,
                                size: "x-small",
                                color: "primary",
                                variant: "flat",
                                class: "important-badge"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" NEW ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(news.nc_type === 'ADMIN' ? '관리자' : news.nc_sisul_name || '-'), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(formatDate(news.nc_wdate)), 1)
                    ])
                  ], 10, _hoisted_7))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_v_icon, {
                    size: "48",
                    color: "grey-lighten-2"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-bulletin-board", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "empty-text" }, "현재 공지사항이 없습니다", -1))
                ]))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})